<template>
  <button @click="goBack" class="back-btn" :class="buttonClass">Voltar</button>
</template>
<script>
export default {
  data() {
    return {};
  },
  name: "BackButton",
  props: ["variant"],
  components: {},
  computed: {
    buttonClass() {
      return this.variant === "link" ? "link" : "outline";
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.back-btn {
  border-radius: 3px;
  color: #e76752;
  border-radius: 3px;
}

.outline {
  border: 2px solid #e76752;
  background-color: transparent;
  padding: 10px 30px;
}

.outline:hover {
  background-color: #e76752;
  color: white;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.255);
}

.link {
  background-color: transparent;
  color: #e76752;
  text-decoration: underline;
  border: none;
  padding-bottom: 5px;
}

.link:hover {
  color: #e76752;
  text-decoration: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.255);
}
</style>
